import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { StyledEngineProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import { DemoContainer , DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";


const InstallationWCRCompleted = () => {

  const navigate = useNavigate();
    const [activeForm, setActiveForm] = useState("form1");
    const [itemConsump,setItemConsump] = useState([]);
    const [manhole,setManhole] = useState([]);
    const [serviceConsump,setServiceConsump] = useState([])
    const [engCreatedOn,setEngCreatedOn]= useState()
    const [userCstmrDetails, setUserCstmrDetails] = useState({
        BusinessSegment:"",
        Pod : "",
        Product : "",
        IDBlength : "",
        LinkBudget : "",
        fmsfirst: "",
        fmssecond: "",
        podendfmsno: "",
        portnocxend: "",
        portnopodend: "",
        EngName: "",
        InstCode: "",
        WCRCreatedon: "",
        WCRRemarks : "",
        MiscWorkCost : ""
       });

       const redirectProvisoning = () => {
        navigate("/installationprovisioning")
       }
      const parseDate = (dateString) => {
        const formatDate1 = (dateString) => {
          const [day, month, year] = dateString.split('/');
          if (!day || !month || !year) return null;
          return `${year}-${month}-${day}`;
        };
      
        const formatDate2 = (dateString) => {
          const [month, day, year] = dateString.split('-');
          if (!day || !month || !year) return null;
          return `${year}-${month}-${day}`;
        };
      
        const formattedDate1 = formatDate1(dateString);
        if (formattedDate1 && !isNaN(Date.parse(formattedDate1))) {
          return formattedDate1;
        }
      
        const formattedDate2 = formatDate2(dateString);
        if (formattedDate2 && !isNaN(Date.parse(formattedDate2))) {
          return formattedDate2;
        }
      
        return null;
      };
      
      const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setUserCstmrDetails({ ...userCstmrDetails, [e.target.name]: e.target.value });
      };

    const handleIconClick = (formId) => {
        setActiveForm((prevActiveBox) =>
          prevActiveBox === formId ? null : formId
        );
      };
      useEffect(() => {
        if (userCstmrDetails && userCstmrDetails.WCRCreatedon) {
          // console.log("userCstmrDetails.WCRCreatedon", userCstmrDetails.WCRCreatedon);
          const formattedDate = parseDate(userCstmrDetails.WCRCreatedon);
    
          if (formattedDate) {
            setEngCreatedOn(formattedDate);
          } else {
            console.error("Failed to parse date:", userCstmrDetails.WCRCreatedon);
          }
        }
      }, [userCstmrDetails]);

    const handleCreatedOn = (e) =>{
        setEngCreatedOn(e.target.value)
    }

      useEffect(() => {
        const fetchData = async () => {
          try {
            //   setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
              Action: "ffaGetWCRInfo",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              CanId: sessionStorage.getItem("CanId"),
              OrderId: sessionStorage.getItem("OrderID"),
            };
            const response = await fetch(apiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestData),
            });
            if (response.ok) {
              const result = await response.json();
              // console.log('API Response:', result);
              if (
                result &&
                result.Response &&
                result.Response.Status !== "Failure"
              ) {
                // console.log('get WCR Actual Data:', result.Response);
                setServiceConsump(result.Response.serviceConsumtionList)
                setItemConsump(result.Response.itemConsumtionList);
                setManhole(result.Response.ManHoleDetailsList)
               setUserCstmrDetails ({
                BusinessSegment:result.Response.WCR.BusinessSegment ? result.Response.WCR.BusinessSegment : '',
                Pod : result.Response.WCR.Pod ? result.Response.WCR.Pod : '',
                Product : result.Response.WCR.Product ? result.Response.WCR.Product : '',
                IDBlength : result.Response.Associated.IDBlength,
                LinkBudget : result.Response.Associated.IDBlength,
                fmsfirst: result.Response.FMSDetails.fmsfirst,
                fmssecond: result.Response.FMSDetails.fmssecond,
                podendfmsno: result.Response.FMSDetails.podendfmsno,
                portnocxend: result.Response.FMSDetails.portnocxend,
                portnopodend: result.Response.FMSDetails.portnopodend,
                EngName: result.Response.EngineerDetails.EngName,
                InstCode: result.Response.EngineerDetails.InstCode,
                WCRCreatedon: result.Response.EngineerDetails.WCRCreatedon,
                WCRRemarks :  result.Response.EngineerDetails.WCRRemarks,
                MiscWorkCost : result.Response.WCR.MiscWorkCost,
                WCRConsumptionStatus : result.Response.WCR.WCRConsumptionStatus

               })
                // let tt = [];
                // tt.push(result.Response);
                // setWcrInfo(tt);
                // console.log("ffaGetWCRInfo", result.Response, "tt", tt);
    
                // sessionStorage.setItem('wcrId', result.Response.WCR.WCRGUIDID);
                // setWCRGUIDID(result.Response.WCR.WCRGUIDID)
              } else {
                const errorMessage =
                  result && result.Response && result.Response.Message;
                // console.log("errorMessage",errorMessage);
                toast.warning(`${errorMessage}`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
              }
            } else {
              console.error("Error fetching data:", response.status);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          } finally {
            //   setLoading(false);
          }
        };
        fetchData();
      }, []);
    return(
        <>
         {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectProvisoning}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">WCR</span>
        </div>
      </div>
      {/* ************Header end************ */}

      <div className="container-fluid irwcr-container text-center">
        <span className="wcr-status">
          WCR Status :{" "}
          {userCstmrDetails ? userCstmrDetails.WCRConsumptionStatus : ""}
        </span>

        <hr />
      </div>
      <div className="container-fluid irwcr-container-cstm text-center ">
        <span className="wcr-status ">
        <div className=" text-center mb-3">
          <button
            type="button"
            className="btn text-light ir-btn mx-auto rounded-pill"
            onClick=""
          >
            RESEND SERVICE ACTIVATION CODE
          </button>
        </div>
        <div className=" text-center ">
          <button
            type="button"
            className="btn text-light ir-btn mx-auto rounded-pill"
            onClick=""
          >
             RESEND INSTALLTION CODE
          </button>
        </div>
        </span>

        <hr />
      </div>

      <div className="container-fluid">
        {/* **************Contact Information toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Customer Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* **************Contact Information toggle******************* */}

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2 m-1">
              <p className="wcr-customer-detail">
                 Business segment :{" "}
                {userCstmrDetails ? userCstmrDetails.BusinessSegment : ""}
              </p>
              <p className="wcr-customer-detail">
                POD : {userCstmrDetails ? userCstmrDetails.Pod : ""}
              </p>
              <p className="wcr-customer-detail">
                Product : {userCstmrDetails ? userCstmrDetails.Product : ""}
              </p>
            </form>
          </div>
        )}
         {/* **************Associated Entities  Information toggle******************* */}
         <div
          className="contact-toggle"
          onClick={() => handleIconClick("form2")}
        >
          <span className="toggle-text">Associated Entites Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* **************Associated Entities toggle******************* */}

        {activeForm === "form2" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form2"
          >
            {/**********Associated Entities form******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="idbLength"
                  name="IDBlength"
                  value={userCstmrDetails.IDBlength}
                    onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  IDB Length
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="linkBudget"
                  name="LinkBudget"
                  value={
                    userCstmrDetails ? userCstmrDetails.LinkBudget : ""
                  }
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                 Link Budget
                </label>
              </div>
            </form>
          </div>
        )}

         {/* **************FMS  Information toggle******************* */}
         <div
          className="contact-toggle"
          onClick={() => handleIconClick("form3")}
        >
          <span className="toggle-text">FMS Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* **************FMS toggle******************* */}

             {activeForm === "form3" && (
                <div
                  className=" container shadow mb-3 bg-body rounded mt-4"
                  id="form2"
                >
         <form className="contact-form p-2">
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="fmsfirst"
             name="fmsfirst"
             value={userCstmrDetails.fmsfirst}
               onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
            Customer END FMS (First Level)
           </label>
         </div>
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="fmssecond"
             name="fmssecond"
             value={ userCstmrDetails.fmssecond }
             onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           Customer END FMS (Second Level)
           </label>
         </div>
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="podendfmsno"
             name="podendfmsno"
             value={
userCstmrDetails.podendfmsno
             }
             onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           POD End FMS No.
           </label>
         </div>
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="portnocxend"
             name="portnocxend"
             value={ userCstmrDetails.portnocxend }
             onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           PORT Number (Cx End)
           </label>
         </div>
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="portnopodend"
             name="portnopodend"
             value={
              userCstmrDetails.portnopodend
             }
             onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           PORT Number (POD End)
           </label>
         </div>
       </form>
       </div>
        )}

         {/* **************ITEM Consumption Information toggle******************* */}
         <div
          className="contact-toggle"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Item Consumption Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* **************ITEM Consumption toggle******************* */}

        {activeForm === "form4" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2 m-1">
            {itemConsump.map((item, index) => (
        <div className="col" key={index}>
          <div className="card mb-3">
            <div className="m-2 card-data">
              <div>
                <p className="wcr-card-text">Item : {item.Item}</p>
                <p className="wcr-card-text">SubItem : {item.SubItem}</p>
                <p className="wcr-card-text">ItemType : {item.ItemType}</p>
                <p className="wcr-card-text">ItemCode : {item.ItemCode}</p>
                <p className="wcr-card-text">Serial Num : {item.SerialNumber}</p>
                <p className="wcr-card-text">Quantity : {item.Quantity}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </form>
          </div>
        )}

          {/* **************MANHOLE Information toggle******************* */}
          <div
          className="contact-toggle"
          onClick={() => handleIconClick("form5")}
        >
          <span className="toggle-text">Manhole Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {/* **************MANHOLE Consumption toggle******************* */}

        {activeForm === "form5" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form5"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2 m-1">
          
            {manhole.length > 0 ? (
        manhole.map((item, index) => (
          <div className="col" key={index}>
            <div className="card mb-3">
              <div className="m-2 card-data">
                <div>
                  <p className="wcr-card-text">Fiber No Running No Wise: {item.FiberNoRunningNoWise}</p>
                  <p className="wcr-card-text">Fiber Tube: {item.FiberTube}</p>
                  <p className="wcr-card-text">Distance: {item.Distance}</p>
                  <p className="wcr-card-text">Manhole Type: {item.ManHoleType}</p>
                  <p className="wcr-card-text">Fiber No Tube Wise: {item.FiberNoTubeWise}</p>
                  <p className="wcr-card-text">Fiber Cable: {item.FiberCable}</p>
                  <p className="wcr-card-text">Location Landmark: {item.LocationLandmark}</p>
                  <p className="wcr-card-text">Can ID: {item.CANID}</p>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="col">
          <div className="card mb-3">
            <div className="m-2 card-data">
              <div>
                <p className="wcr-card-text">No data available</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </form>
          </div>
        )}



        {/* **************Engineer Information toggle******************* */}
        <div
                className="contact-toggle"
                onClick={() => handleIconClick("form6")}
                >
                <span className="toggle-text">Engineer Details</span>
                <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                </span>
                </div>
        {/* **************Engineer  toggle******************* */}

        {activeForm === "form6" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form6"
          >
            {/**********Engineer Information form******** */}
            <form className="contact-form p-2">
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="EngName"
             name="EngName"
             value={
           userCstmrDetails.EngName 
             }
               onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           Engineer Name
           </label>
         </div>
         <div className="input-box form-floating">
           <input
             type="tel"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="InstCode"
             name="InstCode"
             maxLength="6"
                        pattern="[0-9]{10}"
             value={
                userCstmrDetails.InstCode 
             }
             onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                const isDigit = /\d/.test(e.key);
                if (
                  (isDigit || allowedKeys.includes(e.key)) &&
                  (userCstmrDetails.InstCode.length < 6 || e.key === "Backspace")
                ) {
                  return true;
                } else {
                  e.preventDefault();
                }
              }}
              onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
         Installation Code
           </label>
         </div>
         <div className="input-box form-floating">
           <input
             type="date"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="businessSegment"
             name="businessSegment"
             value={engCreatedOn}
               onChange={handleCreatedOn}
           />
           <label htmlFor="floatingInput" className="mt-2">
          Created On
           </label>
         </div>
         </form>
          </div>
        )}


       {/* **************Service Consumption toggle******************* */}
       <div
                className="contact-toggle"
                onClick={() => handleIconClick("form7")}
                >
                <span className="toggle-text">Service Consumption </span>
                <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                </span>
                </div>
        {/* **************Service  toggle******************* */}

        {activeForm === "form7" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form7"
          >
            {/**********Engineer Information form******** */}
            <form className="contact-form p-2 m-1">
            {serviceConsump.map((item, index) => (
        <div className="col" key={index}>
          <div className="card mb-3">
            <div className="m-2 card-data">
              <div>
                <p className="wcr-card-text">Item : {item.Item}</p>
                <p className="wcr-card-text">SubItem : {item.SubItem}</p>
                <p className="wcr-card-text">ItemType : {item.ItemType}</p>
                <p className="wcr-card-text">ItemCode : {item.ItemCode}</p>
             
              </div>
            </div>
          </div>
        </div>
      ))}
    </form>
          </div>
        )}

        {/* **************Remarks  toggle******************* */}
       <div
                className="contact-toggle"
                onClick={() => handleIconClick("form8")}
                >
                <span className="toggle-text">Remarks</span>
                <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                </span>
                </div>
        {/* **************Remarks  toggle******************* */}

        {activeForm === "form8" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form8"
          >
            {/**********Remarks Information form******** */}
            <form className="contact-form p-2">
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="WCRRemarks"
             name="WCRRemarks"
             value={
 userCstmrDetails.WCRRemarks 
             }
               onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           Remarks
           </label>
         </div>
         </form>
          </div>
        )}

         {/* **************Misc. Work Cost  toggle******************* */}
       <div
                className="contact-toggle"
                onClick={() => handleIconClick("form9")}
                >
                <span className="toggle-text">Misc. Work Cost</span>
                <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                </span>
                </div>
        {/* **************Misc. Work Cost  toggle******************* */}

        {activeForm === "form9" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form9"
          >
            {/**********Misc. Work Cost Information form******** */}
            <form className="contact-form p-2">
         <div className="input-box form-floating">
           <input
             type="text"
             placeholder=""
             className=" form-control input-text form-control-sm mt-1"
             id="MiscWorkCost"
             name="MiscWorkCost"
             value={
 userCstmrDetails.MiscWorkCost 
             }
               onChange={handleChange}
           />
           <label htmlFor="floatingInput" className="mt-2">
           Misc Work Cost
           </label>
         </div>
         </form>
          </div>
        )}



















        </div>
</>
    )
}
export default InstallationWCRCompleted